<div (sizeChanged)="sizeChanged.emit($event)" class="page-header" [ngClass]="{'page-header_fixed' : fixed}"
     mbsSizeObserver>
  <mbs-alert-container></mbs-alert-container>
  <div class="page-header__content">
    <ng-content></ng-content>
  </div>
</div>
